<script lang="ts">
  import ComboboxSuggestions from '@athena-lib/Fields/TextField/ComboboxSuggestions.svelte';
  import TextField from '@athena-lib/Fields/TextField/TextField.svelte';
  import debouncedFunc from '@athena-lib/timing-utils';
  import { usePromise } from '@athena-lib/usePromise.svelte';
  import { Type, type Static } from '@sinclair/typebox';
  import { Value } from '@sinclair/typebox/value';

  const detailsSchema = Type.Object({
    address1: Type.String(),
    city: Type.String(),
    postalCode: Type.String(),
    country_code: Type.String(),
    stateOrProvince: Type.String(),
  });
  let {
    streetAddress = $bindable(),
    error,
    onPickAddress,
    onchange,
    type,
    label,
    country,
  }: {
    error?: string;
    streetAddress: string;
    onPickAddress: (details: Static<typeof detailsSchema>) => void;
    onchange?: () => void;
    country: string;
    label: string;
    type: 'billing' | 'shipping';
  } = $props();
  let inputElem = $state<HTMLInputElement | undefined>(undefined);
  const changeSearchValue = debouncedFunc((value: string) => {
    searchValue = value;
  }, 200);
  let searchValue = $state('');
  const suggestionPromise = $derived(
    searchValue.trim()
      ? fetch('/api/location-autocomplete', {
          method: 'POST',

          body: JSON.stringify({ query: searchValue, country: country }),
        })
          .then((x) => x.json())
          .then((x) =>
            Value.Decode(Type.Array(Type.Object({ id: Type.String(), label: Type.String() })), x),
          )
      : Promise.resolve([]),
  );
  const value = usePromise(() => suggestionPromise);
  const suggestions = $derived(value.value ?? []);

  const getDetails = (id: string) =>
    fetch('/api/location-details', { method: 'POST', body: id })
      .then((x) => x.json())
      .then((x) => Value.Decode(detailsSchema, x))
      .then((x) => {
        onPickAddress(x);
      });
</script>

<ComboboxSuggestions
  inputElement={inputElem}
  suggestions={suggestions.map((x) => ({
    label: x.label,
    onClick: () => {
      getDetails(x.id);
    },
  }))}
>
  {#snippet renderSuggestion(label)}
    <div class="p-2">{label}</div>
  {/snippet}
  {#snippet children(helperElement, handleEvent)}
    <TextField
      bind:inputElement={inputElem}
      autocomplete={`${type} address-line1`}
      onkeyup={(event) => {
        const {
          currentTarget: { value },
        } = event;
        changeSearchValue(value);
        handleEvent(event);
      }}
      {error}
      {onchange}
      {label}
      bind:value={streetAddress}
      {helperElement}
    />
  {/snippet}
</ComboboxSuggestions>
